import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import OperationalManagementTable from "./components/operational-management-table";

function OperationalManagement() {
  return (
    <ToastProvider>
      <Dashboard>
        <OperationalManagementTable />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}

export default OperationalManagement;